import { render, staticRenderFns } from "./SettingsTab.vue?vue&type=template&id=6a2b2a72&scoped=true&"
import script from "./SettingsTab.vue?vue&type=script&lang=js&"
export * from "./SettingsTab.vue?vue&type=script&lang=js&"
import style0 from "./SettingsTab.vue?vue&type=style&index=0&id=6a2b2a72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2b2a72",
  null
  
)

export default component.exports